import React from "react";
import { HiOutlineQuestionMarkCircle } from "react-icons/hi";
import { IconContext } from "react-icons";
import WithTooltip from "./WithTooltip";

const Help: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  // TODO aria-describedby, role=tooltip
  return (
    <WithTooltip tooltip={children}>
      <IconContext.Provider value={{}}>
        <HiOutlineQuestionMarkCircle className="ml-1 text-gray-500" />
      </IconContext.Provider>
    </WithTooltip>
  );
};

export default Help;
